'use client';

import { ImageBj } from '@components/common';
import { cn } from '@utils/cn';
import bestieImage from '@images/bestie/bestie-rocket.png';

interface Props {
  className?: string;
}

const BestieAvatar = ({ className }:Props) => (
  <div className={cn('relative size-32 overflow-hidden rounded-full', className)}>
    <ImageBj
      priority
      src={bestieImage}
      alt="Bestie"
      className="size-full scale-125 object-cover object-top"
    />
  </div>
);

export default BestieAvatar;
